import { LeftSide } from "../../../components/desktop/left-side/left-side";
import styles from "./main-content-layout.module.scss";

type Props = {
  children: React.ReactNode;
};

export function MainContentLayout({ children }: Props) {
  return (
    <div className={styles.mainComponentWrapper}>
      {/* left side */}
      <aside className={styles.aside}>
        <LeftSide />
      </aside>
      {/* right side */}
      <div className={styles.rightSide}>{children}</div>
    </div>
  );
}
